import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "@/components/toast/toast-queue";
import { profileKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useAssignBrandsToUser(userId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (brandIds: number[]) =>
      apiClient.url(`/users/${userId}/brands`).put({ brandIds }).res(),
    onError: () => {
      toast.add({
        description: "Failed to update brands",
        timeout: 3000,
        type: "error",
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: profileKeys.brandsByUserId(userId),
      });
      toast.add({
        description: "Brands updated successfully",
        timeout: 3000,
        type: "success",
      });
    },
  });
}
